import styled, { css } from 'styled-components';
import { breakpointMap, theme } from '../../../theme';
import { StyledContentCardProps } from './ContentCard';

const { spacings } = theme;

const ContentCardLowerStylesSmall = css`
  padding: ${spacings[5].rem} ${spacings[3].rem};
`;

const ContentCardLowerStylesLarge = css`
  padding: ${spacings[7].rem} ${spacings[4].rem} ${spacings[5].rem};
`;

const lowerStyles = {
  small: ContentCardLowerStylesSmall,
  large: ContentCardLowerStylesLarge,
};

export const ContentCardLower = styled.div<{
  cardSize: StyledContentCardProps['size'];
}>`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  width: 100%;
  ${({ cardSize }) => breakpointMap(cardSize, (size) => lowerStyles[size])};
`;
